import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';

import { Profile } from '@df/interfaces';
import { AccountService } from '@app/teacher/services/account.service';
import { NotificationsService } from '@app/core/services';
import { HandlerService } from '@app/_services/handler.service';

@Component({
    selector: 'app-profile-data',
    templateUrl: './profile-data.component.html',
    styleUrls: ['./profile-data.component.scss']
})
export class ProfileDataComponent implements OnInit {
    @ViewChild('confirmEmail', { static: true }) confirmEmail: TemplateRef<any>;
    form: FormGroup;
    profile: Profile;
    showGroups = false;
    firstNameExist = true;
    lastNameExist = false;
    middleNameExist = false;
    emailExist = true;
    phoneExist = false;
    dialogRef: any;
    notification = '';

    constructor(
        private accountService: AccountService,
        private notificationsService: NotificationsService,
        private handlerService: HandlerService,
        private route: ActivatedRoute,
        public dialog: MatDialog,
        private fb: FormBuilder
    ) {}

    ngOnInit() {
        this.route.data.subscribe(data => {
            this.profile = data.profile.data;
            setTimeout(() => this.checkUserInfo());
        });
        this.form = this.fb.group({
            firstName: [
                '',
                [
                    Validators.required,
                    Validators.minLength(3),
                    Validators.maxLength(35),
                    Validators.pattern('[A-Za-zА-Яа-я]+')
                ]
            ],
            lastName: [
                '',
                [
                    Validators.required,
                    Validators.minLength(4),
                    Validators.maxLength(30),
                    Validators.pattern('[A-Za-zА-Яа-я]+')
                ]
            ],
            middleName: [
                '',
                [Validators.minLength(2), Validators.maxLength(30), Validators.pattern('[A-Za-zА-Яа-я]+')]
            ],
            email: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(35), Validators.email]],
            phone: ['', [Validators.pattern('[0-9 ]{11}')]],
            confirmDataUsage: [false, [Validators.requiredTrue]]
        });

        this.notificationsService.getFirstParentNotification().subscribe(resp => {
            this.handlerService.checkErrors(resp);

            if (!resp.error && resp.data) {
                this.notification = resp.data.description;
            }
        });
    }

    openDialog(): void {
        this.dialogRef = this.dialog.open(this.confirmEmail, {
            width: '720px',
            height: '240px'
        });
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    checkUserInfo(): void {
        const regexpTemplate = /pu|parent_|user_/;
        const isDefaultUserEmail = this.profile.user.email.split('_');
        const isDefaultFirstName = this.profile.user.first_name.match(regexpTemplate);

        if (!this.profile.user.first_name || (isDefaultFirstName && isDefaultFirstName.index === 0)) {
            this.firstNameExist = false;
        }

        if (this.profile.user.last_name) {
            this.lastNameExist = true;
        }

        if (this.profile.middle_name) {
            this.middleNameExist = true;
        }

        if (!this.profile.user.email || (isDefaultUserEmail.length && isDefaultUserEmail[1] === 'parent')) {
            this.emailExist = false;
        }

        if (this.profile.phone) {
            this.phoneExist = true;
        }

        this.form.patchValue({
            firstName: this.firstNameExist ? this.profile.user.first_name : '',
            lastName: this.lastNameExist ? this.profile.user.last_name : '',
            middleName: this.middleNameExist ? this.profile.middle_name : '',
            email: this.emailExist ? this.profile.user.email : '',
            phone: this.phoneExist ? this.profile.phone.replace('+7', '8') : ''
        });
    }

    deactivateUser(userId): void {
        this.accountService.deactivateUser(userId).subscribe();
    }

    onSubmit() {
        if (this.form.valid) {
            const { firstName, lastName, middleName, email, phone } = this.form.value;
            this.profile.user.first_name = firstName || this.profile.user.first_name;
            this.profile.user.last_name = lastName || this.profile.user.last_name;
            this.profile.user.is_active = false;
            this.profile.user.email = email || this.profile.user.email;
            this.profile.phone = phone || this.profile.phone;
            this.profile.middle_name = middleName || this.profile.middle_name;

            this.accountService.patchProfile(this.profile).subscribe(resp => {
                if (!resp.error) {
                    this.accountService.sendConfirmEmail(this.profile.user.id).subscribe(resp => {
                        if (resp.success) {
                            this.deactivateUser(this.profile.user.id);
                            this.openDialog();
                        }
                    });
                }
            });
        }
    }
}
